export default function isNotNullable<T>(value: T): value is Exclude<T, null | undefined> {
    return typeof value !== 'undefined' && value !== null;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('isNotNullable', () => {
        it('returns false for values that resolves to False', () => {
            expect(isNotNullable(undefined)).toBe(false);
            expect(isNotNullable(null)).toBe(false);
        });

        it('returns true for values that resolves to True', () => {
            expect(isNotNullable(false)).toBe(true);
            expect(isNotNullable(0)).toBe(true);
            expect(isNotNullable('')).toBe(true);
            expect(isNotNullable(true)).toBe(true);
            expect(isNotNullable(1)).toBe(true);
            expect(isNotNullable(0.1)).toBe(true);
            expect(isNotNullable(-1)).toBe(true);
            expect(isNotNullable('a')).toBe(true);
            expect(isNotNullable('0')).toBe(true);
            expect(isNotNullable(' ')).toBe(true);
            expect(isNotNullable({})).toBe(true);
            expect(isNotNullable([])).toBe(true);
            expect(isNotNullable(() => {})).toBe(true);
        });
    });
}

// #endregion
